document.addEventListener('DOMContentLoaded', () => {
  const tableOfContentsItemProp = 'tableOfContents';

  const getArticleBody = () => {
    return document.getElementById('ArticleContentWithToc');
  };

  const isTocEnabled = () => {
    const articleBody = getArticleBody();
    return articleBody?.dataset?.tocEnabled === 'true';
  };

  const getHeadings = () => {
    const articleBody = getArticleBody();
    if (!articleBody) return [];
    return Array.from(articleBody.querySelectorAll('h2, h3'));
  };

  const existsTableOfContents = () => {
    const articleBody = getArticleBody();
    if (!articleBody) return false;
    return !!articleBody.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\wぁ-んァ-ン一-龥ー]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const ensureHeadingIds = (headings) => {
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id = heading.id?.trim();

      if (!id) {
        id = generateSlug(heading.textContent || '') || `section-${index + 1}`;
      }

      let uniqueId = id;
      let count = 2;
      while (
        usedIds.has(uniqueId) ||
        (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)
      ) {
        uniqueId = `${id}-${count}`;
        count += 1;
      }

      heading.id = uniqueId;
      usedIds.add(uniqueId);
    });
  };

  const generateAnchor = (id, text) => {
    const anchor = document.createElement('a');
    anchor.href = `#${id}`;
    anchor.textContent = text;
    anchor.style.display = 'block';
    anchor.style.width = '100%';
    anchor.style.padding = '0';
    anchor.style.margin = '0';
    anchor.style.lineHeight = '21px';
    anchor.style.fontSize = '1.6rem';
    anchor.style.color = '#483327';
    anchor.style.textDecoration = 'none';
    return anchor;
  };

  const generateListItem = (id, text, isNest = false) => {
    const listItem = document.createElement('li');
    listItem.style.padding = '8px 0';
    listItem.style.margin = '0';

    if (isNest) {
      listItem.style.listStyle = 'none';
      listItem.style.paddingLeft = '0';
    } else {
      listItem.style.listStyle = 'decimal-leading-zero';
    }

    listItem.appendChild(generateAnchor(id, text));
    return listItem;
  };

  const generateList = (headings) => {
    if (!headings.length) return null;

    const list = document.createElement('ol');
    list.classList.add('toc-list');

    let currentH2Item = null;
    let currentNestedList = null;

    headings.forEach((heading) => {
      const text = heading.textContent.trim();
      if (!text || !heading.id) return;

      if (heading.tagName === 'H2') {
        const listItem = generateListItem(heading.id, text, false);
        list.appendChild(listItem);

        currentH2Item = listItem;
        currentNestedList = null;
        return;
      }

      if (heading.tagName === 'H3') {
        const nestedItem = generateListItem(heading.id, text, true);

        if (!currentH2Item) {
          list.appendChild(nestedItem);
          return;
        }

        if (!currentNestedList) {
          currentNestedList = document.createElement('ul');
          currentNestedList.classList.add('toc-sub-list');
          currentNestedList.style.margin = '8px 0 0';
          currentNestedList.style.paddingLeft = '2rem';
          currentNestedList.style.listStyle = 'none';

          currentH2Item.appendChild(currentNestedList);
        }

        currentNestedList.appendChild(nestedItem);
      }
    });

    return list;
  };

  const generateTitle = () => {
    const title = document.createElement('p');
    title.textContent = 'この記事の目次';
    title.style.fontSize = '1.9rem';
    title.style.fontWeight = '500';
    title.style.margin = '0';
    title.style.color = '#000';
    title.style.lineHeight = '1.5';
    title.style.letterSpacing = '0.04em';
    title.style.textAlign = 'center';
    return title;
  };

  const generateTableOfContents = (headings) => {
    const list = generateList(headings);
    if (!list) return null;

    const nav = document.createElement('nav');
    nav.setAttribute('itemprop', tableOfContentsItemProp);
    nav.style.padding = '3rem 2rem';
    nav.style.margin = '36px 0';
    nav.style.border = '2px solid #333';
    nav.style.borderRadius = '15px';
    nav.style.backgroundColor = '#fafafa';

    nav.appendChild(generateTitle());
    nav.appendChild(list);

    return nav;
  };

  const getInsertTarget = (firstHeading, articleBody) => {
    if (!firstHeading || !articleBody) return null;

    const block = firstHeading.closest('.mb40, .mb20, div, section');
    if (block && block.parentNode === articleBody) {
      return block;
    }

    if (firstHeading.parentNode === articleBody) {
      return firstHeading;
    }

    return null;
  };

  const addTableOfContents = () => {
    if (!isTocEnabled()) return;

    const articleBody = getArticleBody();
    if (!articleBody || existsTableOfContents()) return;

    const headings = getHeadings();
    if (!headings.length) return;

    ensureHeadingIds(headings);

    const toc = generateTableOfContents(headings);
    if (!toc) return;

    const firstHeading = headings[0];
    const insertTarget = getInsertTarget(firstHeading, articleBody);

    if (insertTarget) {
      articleBody.insertBefore(toc, insertTarget);
    } else {
      articleBody.prepend(toc);
    }
  };

  // スムーズスクロール処理
  const enableSmoothScroll = () => {
    const tocLinks = document.querySelectorAll('nav[itemprop="tableOfContents"] a');
    tocLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = decodeURIComponent(this.getAttribute('href').substring(1));
        const target = document.getElementById(targetId);
        if (target) {
          const offset = 80; // 固定ヘッダー等があれば調整0
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top,
            behavior: 'smooth'
          });
        }
      });
    });
  };

  addTableOfContents();
  enableSmoothScroll();
});